module.exports = __webpack_public_path__ + "media/St 4-EMU-correct.d761a59b.wav";